(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drb-doctors"] && !Shopify.designMode) return;
  try {
    
/* Panels render visible and the script hides them, so no-JS shows every profile (D-0814) */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const select = (list, index, focus) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
      if (on && focus) tab.focus();
    });
  };

  /* Hover and focus pause indefinitely (WCAG 2.2.2); reduced motion disables the cycle (D-0816) */
  const auto = new WeakMap();

  const advance = (list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    select(list, (current + 1) % tabs.length, false);
  };

  const pauseAuto = (list) => {
    const state = auto.get(list);
    if (!state || !state.id) return;
    window.clearInterval(state.id);
    state.id = null;
  };

  const playAuto = (list) => {
    const state = auto.get(list);
    if (!state || state.held || state.hover || state.focused || state.id || !state.visible) return;
    state.id = window.setInterval(() => advance(list), state.ms);
  };

  const holdAuto = (list) => {
    const state = auto.get(list);
    if (!state) return;
    state.held = true;
    pauseAuto(list);
    if (state.idleId) window.clearTimeout(state.idleId);
    state.idleId = null;
    if (!(state.resumeMs > 0)) return;
    state.idleId = window.setTimeout(() => {
      state.idleId = null;
      state.held = false;
      playAuto(list);
    }, state.resumeMs);
  };

  const armAuto = (list) => {
    const seconds = parseFloat(list.dataset.drbAutoplay || '0');
    if (!(seconds > 0)) return;
    if (reduce.matches) return;
    if (list.querySelectorAll('[role="tab"]').length < 2) return;

    const resume = parseFloat(list.dataset.drbResume || '0');

    auto.set(list, {
      ms: seconds * 1000,
      resumeMs: resume > 0 ? resume * 1000 : 0,
      id: null,
      idleId: null,
      held: false,
      hover: false,
      focused: false,
      visible: false,
    });

    const flag = (key, value) => (event) => {
      if (key === 'hover' && event && event.pointerType === 'touch') return;
      const state = auto.get(list);
      if (!state) return;
      state[key] = value;
      if (value) pauseAuto(list);
      else playAuto(list);
    };

    /* Touch pointers never set hover: pointerleave never fires after a scroll (D-0821) */
    list.addEventListener('pointerenter', flag('hover', true));
    list.addEventListener('pointerleave', flag('hover', false));
    list.addEventListener('focusin', flag('focused', true));
    list.addEventListener('focusout', flag('focused', false));
    list.addEventListener('pointercancel', flag('hover', false));

    /* Threshold 0: a fraction is unreachable for sections taller than the viewport (D-0822) */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const state = auto.get(list);
          if (!state) return;
          state.visible = entry.isIntersecting;
          if (entry.isIntersecting) playAuto(list);
          else pauseAuto(list);
        });
      }, { threshold: 0 }).observe(list.closest('.drb-docs') || list);
    } else {
      const state = auto.get(list);
      state.visible = true;
      playAuto(list);
    }
  };

  const init = () => {
    document.querySelectorAll('[data-drb-tabs]').forEach((list) => {
      if (list.dataset.drbReady === 'true') return;
      list.dataset.drbReady = 'true';

      /* Stacking class added by script only; without JS it would overlap all three panels (D-0823) */
      const section = list.closest('.drb-docs');
      const panels = section && section.querySelector('.drb-docs__panels');
      if (panels) panels.classList.add('is-stacked');

      select(list, 0, false);
      armAuto(list);
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    const list = tab.closest('[data-drb-tabs]');
    if (!list) return;
    holdAuto(list);
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    select(list, tabs.indexOf(tab), false);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    const list = tab.closest('[data-drb-tabs]');
    if (!list) return;

    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    const current = tabs.indexOf(tab);
    let next = null;

    holdAuto(list);

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;

    if (next === null) return;
    event.preventDefault();
    select(list, next, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account open event does not bubble, so listen during capture (D-0908)
  // Anchor to the account button: the header group bottom can sit a row too low (D-0909)
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-hero"] && !Shopify.designMode) return;
  try {
    
/* Range 0 to 10 at 0.1 (101-step limit); long schema info is silently rejected on push (D-0917) */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const state = new WeakMap();

  const slidesOf = (root) => Array.from(root.querySelectorAll('.drb-hero__slide'));
  const dotsOf = (root) => Array.from(root.querySelectorAll('[data-drb-hero-go]'));

  const show = (root, index) => {
    const slides = slidesOf(root);
    if (!slides.length) return;
    const n = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.setAttribute('data-drb-active', i === n ? 'true' : 'false'));
    dotsOf(root).forEach((d, i) => d.setAttribute('aria-current', i === n ? 'true' : 'false'));

    const active = slides[n];
    if (active) {
      const accent = getComputedStyle(active).getPropertyValue('--drb-hero-accent').trim();
      if (accent) root.style.setProperty('--drb-hero-dot', accent);
    }

    const st = state.get(root);
    if (st) st.index = n;
  };

  const stop = (root) => {
    const st = state.get(root);
    if (!st || !st.id) return;
    window.clearInterval(st.id);
    st.id = null;
    root.classList.add('drb-hero--paused');
  };

  const play = (root) => {
    const st = state.get(root);
    if (!st || st.steered || st.hover || st.focused || st.id || !st.visible) return;
    st.id = window.setInterval(() => show(root, st.index + 1), st.ms);
    root.classList.remove('drb-hero--paused');
  };

  const HERO_RESUME_MS = 12000;

  const steer = (root) => {
    const st = state.get(root);
    if (!st) return;
    st.steered = true;
    stop(root);
    root.classList.remove('drb-hero--paused');
    root.classList.add('drb-hero--stopped');

    if (st.resumeId) window.clearTimeout(st.resumeId);
    st.resumeId = null;
    if (!(st.ms > 0) || reduce.matches) return;

    st.resumeId = window.setTimeout(() => {
      st.resumeId = null;
      st.steered = false;
      root.classList.remove('drb-hero--stopped');
      play(root);
    }, HERO_RESUME_MS);
  };

  /* touch-action and user-select rules in the CSS are required for swipes on the copy (D-0922) */
  const DRAG_INTENT = 8;
  const DRAG_COMMIT = 40;
  const DRAG_TRAVEL = 110;
  const PEEK_CAP = 0.85;

  const armGestures = (root) => {
    let g = null;

    /* Remove dragging class first, clear inline styles next frame, so release animates (D-0924) */
    const releasePeek = () => {
      root.classList.remove('drb-hero--dragging');
      window.requestAnimationFrame(() => {
        slidesOf(root).forEach((slide) => {
          slide.style.opacity = '';
          slide.style.visibility = '';
        });
      });
    };

    const endDrag = (commit, dir) => {
      const st = state.get(root);
      g = null;

      if (commit && st) {
        steer(root);
        show(root, st.index + dir);
        releasePeek();
        return;
      }

      releasePeek();
      if (st && st.ms > 0) play(root);
    };

    root.addEventListener('pointerdown', (event) => {
      if (event.button && event.button !== 0) return;
      if (event.target.closest('a, button')) return;
      g = {
        x: event.clientX,
        y: event.clientY,
        id: event.pointerId,
        axis: null,
        dir: 0,
        touch: event.pointerType === 'touch',
      };
    });

    root.addEventListener('pointermove', (event) => {
      if (!g || event.pointerId !== g.id) return;

      const dx = event.clientX - g.x;
      const dy = event.clientY - g.y;

      if (!g.axis) {
        if (Math.abs(dx) < DRAG_INTENT && Math.abs(dy) < DRAG_INTENT) return;
        g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (g.axis === 'y') {
          g = null;
          return;
        }
        stop(root);
        root.classList.add('drb-hero--dragging');
      }

      const slides = slidesOf(root);
      const st = state.get(root);
      if (slides.length < 2 || !st) return;

      const dir = dx < 0 ? 1 : -1;
      if (dir !== g.dir) {
        slides.forEach((slide) => {
          slide.style.opacity = '';
          slide.style.visibility = '';
        });
        g.dir = dir;
      }

      const n = (((st.index + dir) % slides.length) + slides.length) % slides.length;
      const p = Math.min(Math.abs(dx) / DRAG_TRAVEL, 1) * PEEK_CAP;
      const current = slides[st.index];
      const next = slides[n];

      if (current) current.style.opacity = String(1 - p);
      if (next && next !== current) {
        next.style.visibility = 'visible';
        next.style.opacity = String(p);
      }
    });

    root.addEventListener('pointercancel', () => {
      if (g) endDrag(false, 0);
    });

    root.addEventListener('pointerup', (event) => {
      if (!g || event.pointerId !== g.id) return;

      const dx = event.clientX - g.x;
      const dy = event.clientY - g.y;
      const dragged = g.axis === 'x';
      const touch = g.touch;

      if (dragged) {
        endDrag(Math.abs(dx) >= DRAG_COMMIT, dx < 0 ? 1 : -1);
        return;
      }

      g = null;
      const st = state.get(root);
      if (!st) return;

      /* Tap-to-advance is mouse only: on touch it fired on accidental taps (D-0931) */
      if (touch) return;
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
        if (event.target.closest('.drb-hero__copy')) return;
        const rect = root.getBoundingClientRect();
        steer(root);
        show(root, st.index + (event.clientX - rect.left > rect.width / 2 ? 1 : -1));
      }
    });
  };

  const arm = (root) => {
    if (root.dataset.drbReady === 'true') return;
    root.dataset.drbReady = 'true';

    const seconds = parseFloat(root.dataset.drbHeroSeconds || '0');
    state.set(root, {
      index: 0,
      ms: seconds > 0 ? seconds * 1000 : 0,
      id: null,
      steered: false,
      resumeId: null,
      hover: false,
      focused: false,
      visible: false,
    });

    show(root, 0);

    if (slidesOf(root).length > 1) armGestures(root);

    /* Reduced motion: no auto-rotation; dots still work (D-0933) */
    if (!(seconds > 0) || reduce.matches || slidesOf(root).length < 2) return;

    const flag = (key, value) => (event) => {
      if (key === 'hover' && event && event.pointerType === 'touch') return;
      const st = state.get(root);
      if (!st) return;
      st[key] = value;
      if (value) stop(root);
      else play(root);
    };

    /* Touch pointers never set hover: pointerleave never fires after a scroll (D-0934) */
    root.addEventListener('pointerenter', flag('hover', true));
    root.addEventListener('pointerleave', flag('hover', false));
    root.addEventListener('focusin', flag('focused', true));
    root.addEventListener('focusout', flag('focused', false));
    root.addEventListener('pointercancel', flag('hover', false));

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const st = state.get(root);
          if (!st) return;
          st.visible = entry.isIntersecting;
          if (entry.isIntersecting) play(root);
          else stop(root);
        });
      }, { threshold: 0 }).observe(root);
    } else {
      const st = state.get(root);
      st.visible = true;
      play(root);
    }
  };

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-drb-hero-go]');
    if (!dot) return;
    const root = dot.closest('[data-drb-hero]');
    if (!root) return;
    steer(root);
    show(root, parseInt(dot.dataset.drbHeroGo, 10) || 0);
  });

  const init = () => document.querySelectorAll('[data-drb-hero]').forEach(arm);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-practitioners"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Pauses on hover, focus, steering and off screen; reduced motion disables the cycle (D-1179) */
  const state = new WeakMap();

  const slidesOf = (root) => Array.from(root.querySelectorAll('.drb-prac__slide'));

  const show = (root, index) => {
    const slides = slidesOf(root);
    if (!slides.length) return;
    const n = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((s, i) => {
      s.hidden = i !== n;
    });
    root.querySelectorAll('.drb-prac__pip').forEach((pip, i) => {
      pip.classList.toggle('is-on', i === n);
    });
    const s = state.get(root);
    if (s) s.index = n;
  };

  const stop = (root) => {
    const s = state.get(root);
    if (!s || !s.id) return;
    window.clearInterval(s.id);
    s.id = null;
  };

  const play = (root) => {
    const s = state.get(root);
    if (!s || s.steered || s.hover || s.focused || s.id || !s.visible) return;
    s.id = window.setInterval(() => show(root, s.index + 1), s.ms);
  };

  const RESUME_MS = 6000;

  const steer = (root) => {
    const s = state.get(root);
    if (!s) return;
    s.steered = true;
    stop(root);
    if (s.resumeId) window.clearTimeout(s.resumeId);
    s.resumeId = window.setTimeout(() => {
      s.resumeId = null;
      s.steered = false;
      play(root);
    }, RESUME_MS);
  };

  const armSlider = (root) => {
    if (root.dataset.drbReady === 'true') return;
    root.dataset.drbReady = 'true';

    const seconds = parseFloat(root.dataset.drbSeconds || '0');
    state.set(root, {
      index: 0,
      ms: seconds > 0 ? seconds * 1000 : 0,
      id: null,
      steered: false,
      resumeId: null,
      hover: false,
      focused: false,
      visible: false,
    });

    show(root, 0);

    if (!(seconds > 0) || reduce.matches || slidesOf(root).length < 2) return;

    const flag = (key, value) => (event) => {
      if (key === 'hover' && event && event.pointerType === 'touch') return;
      const s = state.get(root);
      if (!s) return;
      s[key] = value;
      if (value) stop(root);
      else play(root);
    };

    /* Touch never sets hover and pointercancel clears it: pointerleave may never fire (D-1182) */
    root.addEventListener('pointerenter', flag('hover', true));
    root.addEventListener('pointerleave', flag('hover', false));
    root.addEventListener('focusin', flag('focused', true));
    root.addEventListener('focusout', flag('focused', false));
    root.addEventListener('pointercancel', flag('hover', false));

    let dragFrom = null;

    root.addEventListener('pointerdown', (event) => {
      if (event.button && event.button !== 0) return;
      if (event.target.closest('button')) return;
      dragFrom = event.clientX;
    });

    root.addEventListener('pointercancel', () => {
      dragFrom = null;
    });

    root.addEventListener('pointerup', (event) => {
      if (dragFrom === null) return;
      const dx = event.clientX - dragFrom;
      dragFrom = null;
      if (Math.abs(dx) < 40) return;
      const st = state.get(root);
      if (!st) return;
      steer(root);
      show(root, st.index + (dx < 0 ? 1 : -1));
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const s = state.get(root);
          if (!s) return;
          s.visible = entry.isIntersecting;
          if (entry.isIntersecting) play(root);
          else stop(root);
        });
      }, { threshold: 0 }).observe(root);
    } else {
      const s = state.get(root);
      s.visible = true;
      play(root);
    }
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-drb-prev], [data-drb-next]');
    if (!control) return;
    const root = control.closest('[data-drb-slider]');
    if (!root) return;
    const s = state.get(root);
    if (!s) return;
    steer(root);
    show(root, s.index + (control.hasAttribute('data-drb-next') ? 1 : -1));
  });

  /* Lead form, not access control: real prices must never be present in the page (D-1184) */
  const openDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drb-gate-open]');
    if (opener) {
      openDialog(document.getElementById(opener.dataset.drbGateOpen));
      return;
    }

    const closer = event.target.closest('[data-drb-gate-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog && typeof dialog.close === 'function') dialog.close();
      else if (dialog) dialog.removeAttribute('open');
      return;
    }

    const dialog = event.target.closest('dialog.drb-prac__dialog');
    if (!dialog || event.target !== dialog) return;
    const box = dialog.querySelector('.drb-prac__gate');
    if (!box) return;
    const r = box.getBoundingClientRect();
    const inside =
      event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
    if (!inside) dialog.close();
  });

  const init = () => {
    document.querySelectorAll('[data-drb-slider]').forEach(armSlider);

    document.querySelectorAll('.drb-prac__dialog [data-drb-gate-state]').forEach((marker) => {
      openDialog(marker.closest('dialog'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-reviews"] && !Shopify.designMode) return;
  try {
    
/* Conveyor loop: passed cards move to the end with scrollLeft compensated in one frame (D-1262) */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const RESUME_MS = 9000;

  document.querySelectorAll('[data-drb-revrail]').forEach((scroller) => {
    const rail = scroller.querySelector('[data-drb-revrail-rail]');
    if (!rail) return;

    const section = scroller.closest('.drb-revs');
    const stack = section && section.querySelector('[data-drb-revhero]');
    const slides = stack ? Array.prototype.slice.call(stack.children) : [];

    const gap = () => parseFloat(getComputedStyle(rail).columnGap) || 0;

    const width = (card) => (card ? card.getBoundingClientRect().width + gap() : 0);

    const step = () => width(rail.firstElementChild) || rail.clientWidth * 0.8;

    const scrollable = () => rail.scrollWidth > rail.clientWidth + 4;

    const promote = (card) => {
      if (!card || slides.length < 2) return;
      const n = parseInt(card.getAttribute('data-index'), 10);
      if (!isFinite(n)) return;
      Array.prototype.forEach.call(rail.children, (c) =>
        c.classList.toggle('is-current', c === card)
      );
      slides.forEach((slide, i) => {
        const on = i === n + 1;
        slide.classList.toggle('is-on', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
    };

    const normalise = () => {
      let guard = 0;
      while (guard++ < 24) {
        const first = rail.firstElementChild;
        if (!first) return;
        const w = width(first);
        if (w <= 0 || rail.scrollLeft < w - 1) return;
        rail.appendChild(first);
        rail.scrollTo({ left: rail.scrollLeft - w, behavior: 'auto' });
        promote(rail.firstElementChild);
      }
    };

    const forward = () => {
      if (!scrollable()) return;
      rail.scrollTo({
        left: rail.scrollLeft + step(),
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
      if (reduce.matches) normalise();
    };

    const back = () => {
      if (!scrollable()) return;
      const last = rail.lastElementChild;
      if (!last) return;
      const w = width(last);
      rail.insertBefore(last, rail.firstElementChild);
      rail.scrollTo({ left: rail.scrollLeft + w, behavior: 'auto' });
      rail.scrollTo({ left: Math.max(0, rail.scrollLeft - w), behavior: reduce.matches ? 'auto' : 'smooth' });
      promote(rail.firstElementChild);
    };

    /* 2px slack: scrollLeft is fractional on zoomed and high-DPI displays (D-1269) */
    const mark = () => {
      scroller.classList.toggle('is-start', !scrollable() && rail.scrollLeft <= 2);
      scroller.classList.toggle(
        'is-end',
        !scrollable() || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2
      );
    };

    /* Click handler sits above the reduced-motion return: choosing a review is not motion (D-1270) */
    let latched = false;
    rail.addEventListener('click', (event) => {
      const card = event.target.closest('.drb-revs__card');
      if (!card) return;
      const wasCurrent = card.classList.contains('is-current');
      promote(card);
      latched = !(wasCurrent && latched);
      scroller.classList.toggle('is-held', latched);
    });

    let settle = null;
    rail.addEventListener(
      'scroll',
      () => {
        clearTimeout(settle);
        settle = setTimeout(() => {
          normalise();
          mark();
        }, 140);
      },
      { passive: true }
    );

    let held = 0;
    const touch = () => {
      held = Date.now();
    };
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) =>
      scroller.addEventListener(type, touch, { passive: true })
    );

    const prev = scroller.querySelector('[data-drb-revrail-prev]');
    const next = scroller.querySelector('[data-drb-revrail-next]');
    if (prev) prev.addEventListener('click', () => { touch(); back(); });
    if (next) next.addEventListener('click', () => { touch(); forward(); });

    mark();

    /* No autoplay under reduced motion or while the section is off screen (D-1272) */
    if (reduce.matches || scroller.hasAttribute('data-still')) return;

    const seconds = parseFloat(scroller.getAttribute('data-seconds')) || 3;
    const startAfter = parseFloat(scroller.getAttribute('data-start')) || 0;
    let onScreen = false;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => entries.forEach((e) => { onScreen = e.isIntersecting; }),
        { threshold: 0.2 }
      ).observe(scroller);
    } else {
      onScreen = true;
    }

    const tick = () => {
      if (latched) return;
      if (!onScreen || document.hidden) return;
      if (Date.now() - held < RESUME_MS) return;
      if (scroller.matches(':hover')) return;
      if (scroller.contains(document.activeElement)) return;
      forward();
    };

    setTimeout(() => {
      tick();
      setInterval(tick, seconds * 1000);
    }, Math.max(0, startAfter * 1000));
  });
})();

(function () {
  if (window.__drbRevGrid) return;
  window.__drbRevGrid = true;

  function wire(grid) {
    var sec = grid.closest('.drb-revs');
    if (!sec) return;
    var btns = sec.querySelectorAll('[data-drb-rvf]');
    var cards = grid.querySelectorAll('.drb-revs__gcard');
    if (!btns.length || !cards.length) return;

    function apply(key) {
      Array.prototype.forEach.call(cards, function (c) {
        c.hidden = !(key === 'all' || c.getAttribute('data-product') === key);
      });
      Array.prototype.forEach.call(btns, function (b) {
        var on = b.getAttribute('data-drb-rvf') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-drb-rvf')); });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drb-rvgrid]'), wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-study"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-drb-chart-open]');
  if (opener) {
    const modal = opener.closest('.drb-study').querySelector('[data-drb-chart-modal]');
    if (modal && typeof modal.showModal === 'function') modal.showModal();
    return;
  }

  const paper = event.target.closest('[data-drb-paper]');
  if (paper) {
    const modal = paper.closest('.drb-study').querySelector('[data-drb-paper-modal]');
    if (modal && typeof modal.showModal === 'function') {
      event.preventDefault();
      const frame = modal.querySelector('[data-drb-paper-frame]');
      if (frame && !frame.src) frame.src = frame.dataset.src;
      modal.showModal();
    }
    return;
  }

  const closer = event.target.closest('[data-drb-chart-close], [data-drb-paper-close]');
  if (closer) {
    const modal = closer.closest('dialog');
    if (modal) modal.close();
    return;
  }

  const dialog = event.target.closest('[data-drb-chart-modal], [data-drb-paper-modal]');
  if (dialog && event.target === dialog) dialog.close();
});

/* Markup renders the finished state and script winds it back, so failure is safe (D-1316) */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const GAP_MS = 260;
  const LEAD_MS = 220;

  const parseFigure = (raw) => {
    const n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? n : null;
  };

  const durationFor = (n) => Math.min(1500, Math.max(500, 500 + (n / 3700) * 1000));

  const countUp = (el) => {
    const target = parseFigure(el.dataset.drbCount);
    if (target === null) return;
    const suffix = String(el.dataset.drbCount).replace(/[0-9.,]/g, '');
    const dur = durationFor(target);
    let t0 = null;

    const step = (ts) => {
      if (t0 === null) t0 = ts;
      const p = Math.min(1, (ts - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString('en-US') + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = el.dataset.drbCount;
    };

    el.textContent = '0' + suffix;
    requestAnimationFrame(step);
  };

  const playSpine = (spine) => {
    const stages = Array.from(spine.querySelectorAll('[data-drb-stage]'));
    if (!stages.length) return;

    spine.classList.add('is-armed');
    stages.forEach((st) => st.classList.remove('is-active', 'is-done', 'is-filling'));
    spine.style.setProperty('--drb-spine-progress', '0%');

    const run = (i) => {
      if (i >= stages.length) return;
      const stage = stages[i];

      stage.classList.add('is-active', 'is-filling');
      spine.style.setProperty('--drb-spine-progress', Math.round(((i + 1) / stages.length) * 100) + '%');

      const ms = Array.from(stage.querySelectorAll('.drb-study__bar'))
        .reduce((max, bar) => {
          const v = parseFloat(getComputedStyle(bar).getPropertyValue('--drb-bar-ms'));
          return Number.isFinite(v) && v > max ? v : max;
        }, 0) || 800;

      window.setTimeout(() => {
        stage.classList.remove('is-active');
        stage.classList.add('is-done');
        window.setTimeout(() => run(i + 1), GAP_MS);
      }, ms);
    };

    window.setTimeout(() => run(0), LEAD_MS);
  };

  const armed = new WeakSet();

  const start = (el) => {
    if (armed.has(el)) return;
    armed.add(el);
    if (el.matches('[data-drb-spine]')) playSpine(el);
    else el.querySelectorAll('[data-drb-count]').forEach(countUp);
  };

  const init = () => {
    if (reduce.matches) return;

    const spines = [...document.querySelectorAll('[data-drb-spine]')];
    const stats = [...document.querySelectorAll('.drb-study__stats')];
    const targets = [...spines, ...stats];
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(start);
      return;
    }

    /* Two observers on purpose: one threshold cannot suit both short and tall targets (D-1326) */

    const spineIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        spineIo.unobserve(entry.target);
        start(entry.target);
      });
    }, { threshold: 0, rootMargin: '0px' });

    spines.forEach((t) => spineIo.observe(t));

    /* Do not raise the threshold much: the reduced band could never satisfy it (D-1328) */
    const DWELL_MS = 400;
    const dwell = new WeakMap();

    const statsIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (dwell.has(entry.target)) return;
          dwell.set(entry.target, window.setTimeout(() => {
            dwell.delete(entry.target);
            statsIo.unobserve(entry.target);
            start(entry.target);
          }, DWELL_MS));
          return;
        }

        const pending = dwell.get(entry.target);
        if (pending) {
          window.clearTimeout(pending);
          dwell.delete(entry.target);
        }
      });
    }, { threshold: 0.55, rootMargin: '0px 0px -30% 0px' });

    stats.forEach((t) => statsIo.observe(t));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-testimonials"] && !Shopify.designMode) return;
  try {
    
(() => {
  /* Reads the live transform into scrollLeft so the band does not snap back (D-1381) */
  const currentOffset = (track) => {
    const t = getComputedStyle(track).transform;
    if (!t || t === 'none') return 0;
    const m = t.match(/matrix.*\((.+)\)/);
    if (!m) return 0;
    const parts = m[1].split(',').map((n) => parseFloat(n));
    const x = parts.length === 6 ? parts[4] : parts[12];
    return Number.isFinite(x) ? -x : 0;
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const RESUME_MS = 3000;

  const state = new WeakMap();
  const stateOf = (root) => {
    let st = state.get(root);
    if (!st) {
      st = { ms: 0, timer: null, hover: false };
      state.set(root, st);
    }
    return st;
  };

  const durationOf = (track) => {
    const d = getComputedStyle(track).animationDuration || '';
    const n = parseFloat(d);
    if (!Number.isFinite(n) || n <= 0) return 60000;
    return /ms\s*$/.test(d) ? n : n * 1000;
  };

  const armResume = (root) => {
    const st = stateOf(root);
    if (st.timer) window.clearTimeout(st.timer);
    st.timer = null;
    /* Never resume under reduced motion: an endless marquee is a vestibular trigger (D-1385) */
    if (reduceMotion.matches) return;
    st.timer = window.setTimeout(() => {
      st.timer = null;
      if (st.hover) {
        armResume(root);
        return;
      }
      resume(root);
    }, RESUME_MS);
  };

  const goManual = (root) => {
    const section = root.closest('.drb-testis');
    if (!section) return;

    const viewport = root.querySelector('.drb-testis__viewport');
    const track = root.querySelector('.drb-testis__track');
    if (!viewport || !track) return;

    if (section.dataset.drbManual !== 'true') {
      const st = stateOf(root);
      if (!st.ms) st.ms = durationOf(track);

      const offset = currentOffset(track);
      section.dataset.drbManual = 'true';
      section.classList.add('drb-testis--manual');

      /* Do not clear animationDelay here: it restarts the marquee at phase zero (D-1387) */
      viewport.scrollLeft = offset;
    }

    armResume(root);
  };

  const resume = (root) => {
    const section = root.closest('.drb-testis');
    if (!section || section.dataset.drbManual !== 'true') return;

    const viewport = root.querySelector('.drb-testis__viewport');
    const track = root.querySelector('.drb-testis__track');
    if (!viewport || !track) return;

    const st = stateOf(root);
    const group = track.scrollWidth / 2;
    const ms = st.ms || durationOf(track);

    if (group > 0) {
      const phase = (((viewport.scrollLeft % group) + group) % group) / group;
      track.style.animationDelay = '-' + Math.round(phase * ms) + 'ms';
    }

    section.dataset.drbManual = 'false';
    section.classList.remove('drb-testis--manual');
    viewport.scrollLeft = 0;
  };

  const step = (viewport) => {
    const card = viewport.querySelector('.drb-testi');
    if (!card) return Math.round(viewport.clientWidth * 0.8);
    const rect = card.getBoundingClientRect();
    const gap = parseFloat(getComputedStyle(card).marginRight) || 0;
    return Math.round(rect.width + gap);
  };

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-drb-revs-prev], [data-drb-revs-next]');
    if (!arrow) return;
    const root = arrow.closest('[data-drb-revs]');
    if (!root) return;

    goManual(root);

    const viewport = root.querySelector('.drb-testis__viewport');
    if (!viewport) return;
    const dir = arrow.hasAttribute('data-drb-revs-next') ? 1 : -1;
    viewport.scrollBy({ left: dir * step(viewport), behavior: 'smooth' });
  });

  document.addEventListener('pointerover', (event) => {
    const root = event.target.closest && event.target.closest('[data-drb-revs]');
    if (!root || event.pointerType === 'touch') return;
    stateOf(root).hover = true;
  });

  document.addEventListener('pointerout', (event) => {
    const root = event.target.closest && event.target.closest('[data-drb-revs]');
    if (!root || event.pointerType === 'touch') return;
    if (event.relatedTarget && root.contains(event.relatedTarget)) return;
    stateOf(root).hover = false;
  });

  let drag = null;

  document.addEventListener('pointerdown', (event) => {
    const root = event.target.closest('[data-drb-revs]');
    if (!root) return;
    if (event.target.closest('button, a')) return;

    const viewport = root.querySelector('.drb-testis__viewport');
    if (!viewport) return;

    drag = { root, viewport, x: event.clientX, from: 0, moved: false, id: event.pointerId };
  });

  document.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 4) return;
      drag.moved = true;
      goManual(drag.root);
      drag.from = drag.viewport.scrollLeft;
      drag.root.classList.add('drb-testis--dragging');
      drag.viewport.style.userSelect = 'none';
      drag.viewport.style.cursor = 'grabbing';
    }

    let next = drag.from - dx;

    const group = drag.viewport.scrollWidth / 2;
    if (group > 0) {
      while (next >= group) {
        next -= group;
        drag.from -= group;
      }
      while (next < 0) {
        next += group;
        drag.from += group;
      }
    }

    drag.viewport.scrollLeft = next;
    if (event.cancelable) event.preventDefault();
  });

  const endDrag = () => {
    if (!drag) return;
    drag.root.classList.remove('drb-testis--dragging');
    drag.viewport.style.userSelect = '';
    drag.viewport.style.cursor = '';
    if (drag.moved) armResume(drag.root);
    drag = null;
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
